import React, { Component, Fragment } from "react";
import { Card, Tag, Slider, Divider, Collapse, Row, Col } from "antd";
import F from "../../../Functions";
import WizardFooter from "./wizard-footer";
import { Translate } from "react-translated";
import WizardPager from "../../../components/wizard-pager";
import SliderLayout from "./sliderlayout";

const Panel = Collapse.Panel;

class Step extends Component {
  render() {
    const { wizard, updateField, handleBlur, updateRadioBtnToggle } = this.props;

    if (
      wizard.employed_anual_income === null ||
      wizard.employed_anual_income === ""
    ) {
      updateField("employed_anual_income", "$25,001-$50,000");
    }

    if (
      wizard.spouse_first_name &&
      (wizard.employed_anual_income_spouse === null ||
        wizard.employed_anual_income_spouse === "")
    ) {
      updateField("employed_anual_income_spouse", "$0");
    }

    let rangeValues = [
      "$0",
      "$1-$10,000",
      "$10,001-$25,000",
      "$25,001-$50,000",
      "$50,001-$100,000",
      "$100,001-$150,000",
      "$150,001-$200,000",
      "$200,001-$250,000",
      "$250,001-$300,000",
      "$300,001-$350,000",
      "$350,001-$400,000",
      "$400,001-$450,000",
      "$450,001-$500,000",
      "$500,001-$600,000",
      "$600,001-$700,000",
      "$700,001-$800,000",
      "$800,001-$900,000",
      "$900,001-$1,000,000"
    ];
    let v1, v2;
    for (let i = 1; i < 21; i++) {
      v2 = 1000000 + 100000 * i;
      v1 = v2 - 100000 + 1;
      rangeValues.push(F.dollar_format(v1) + "-" + F.dollar_format(v2));
    }
    rangeValues.push("$3,000,001-$4,000,000");
    rangeValues.push("$4,000,001-$5,000,000");

    // let step = 500000;
    //   for (let i = 1; i <= 18; i++) {
    //     v2 = 1000000 + step * i;
    //     v1 = v2 - step + 1;
    //     rangeValues.push(F.dollar_format(v1) + "-" + F.dollar_format(v2));
    //   }

    let marks = {};
    for (let i = 0, rangeLen = rangeValues.length; i < rangeLen; i++) {
      marks[parseInt((i / (rangeLen - 1)) * 100, 10)] = {
        label: i === rangeValues.length - 1 ? rangeValues[i] : "",
        val: rangeValues[i]
      };
    }

    let employed_anual_income = 0;
    if (wizard.employed_anual_income !== "") {
      for (let x in marks) {
        if (marks[x].val === wizard.employed_anual_income) {
          employed_anual_income = parseInt(x, 10);
        }
      }
    }

    let employed_anual_income_spouse = 0;
    if (wizard.employed_anual_income_spouse !== "") {
      for (let x in marks) {
        if (marks[x].val === wizard.employed_anual_income_spouse) {
          employed_anual_income_spouse = parseInt(x, 10);
        }
      }
    }

    return (
      <Fragment>
        <div className="stepBody">
          <Card
            className="insidecard stepcard"
          >
            <h5 className="headingText">
              {
                // this.props.isExternalBFile ?
                //   <Translate text={"Please update the calculator to your annual household income."} /> :
                  <Translate text={"Your income and future earning potential could be exposed in a lawsuit. Our calculator defaults to a range of $25,000 - $50,000 per year, are you ok with that, or would you like me to adjust it?"} />
              }

            </h5>
            <div style={{ marginTop: 20 }} >
              <div
                style={{
                  width: "100%",
                  maxWidth: window.innerWidth > 768 ? "100%" : "400px",
                  margin: "0 auto",
                  padding: "10px",
                }}
              >
                <SliderLayout
                  marks={marks}
                  value={employed_anual_income}
                  name="employed_anual_income"
                  updateField={updateField}
                  updateRadioBtnToggle={updateRadioBtnToggle}
                />
              </div>
              <div className="sliderValue center-align silder-align"
              >
                {wizard.employed_anual_income || "$0"}
              </div>
              {wizard.spouse_first_name && (
                <Collapse defaultActiveKey={["1"]} style={{ marginTop: 20 }}>
                  <Panel header={<Translate text={"Click to add spouse/partner info"} />}>
                    <div style={{ marginTop: 20 }}>
                      <h4 className="titleTextUnderline headingText">
                        <Translate text={`For Spouse/Partner`} />
                      </h4>
                      <SliderLayout
                        marks={marks}
                        value={employed_anual_income_spouse}
                        name="employed_anual_income_spouse"
                        updateField={updateField}
                        updateRadioBtnToggle={updateRadioBtnToggle}
                      />
                      <div className="sliderValue center-align silder-align">
                        {wizard.employed_anual_income_spouse || "$0"}
                      </div>
                    </div>
                  </Panel>
                </Collapse>
              )}
            </div>

            <Row style={{ display: 'flex', justifyContent: 'center' }} className='center'>
              <Col span={18} className='didyouKnowSection'>
                {/* <img src={require("./images/didyouKnow.png")} width={120} className='imgdid' /> */}
                <img src={require('./images/didYouKnowBulb.jpg')} width={40} alt='' />
                <h4>Did You Know</h4>
                <p className="textContent">“If you do not have sufficient insurance to protect your income, it could be exposed for garnishment in a lawsuit.”</p>
              </Col>
            </Row>
            {/* <WizardFooter {...this.props} /> */}
          </Card>
        </div>
        <div className='stepFooter'>
          <WizardFooter {...this.props} />
        </div>
      </Fragment>
    );
  }
}

export default Step;



// WEBPACK FOOTER //
// ./src/scenes/Wizard/parts/step5_1_updated.js